// extracted by mini-css-extract-plugin
module.exports = {"check":"FormSuccessMessage_check__2I5wJ","description":"FormSuccessMessage_description__2QIb4"};